"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const size_const_1 = __importDefault(require("../choices/size.const"));
const color_const_1 = __importDefault(require("../choices/color.const"));
const font_const_1 = __importDefault(require("../choices/font.const"));
const spacing_const_1 = __importDefault(require("../choices/spacing.const"));
const milestoneTracker = {
    // <editor-fold desc="Milestone styling">
    milestoneProgressBarMargin: spacing_const_1.default.md,
    fontFamily: font_const_1.default.family,
    // </editor-fold>
    // <editor-fold desc="Title styling">
    milestoneTitleColorCompleted: color_const_1.default.pickledBluewood800,
    milestoneTitleColorUncompleted: color_const_1.default.cloudyBlue,
    milestoneTitleFontWeight: font_const_1.default.weightAttention,
    milestoneTitleFontSize: font_const_1.default.sizeMd,
    // </editor-fold>
    // <editor-fold desc="Description styling">
    milestoneDescriptionFontColor: color_const_1.default.steel700,
    milestoneDescriptionFontSize: font_const_1.default.sizeSm,
    // </editor-fold>
    // <editor-fold desc="Bullet styling">
    bulletBackgroundColorUncompleted: color_const_1.default.cloudyBlue100,
    bulletBackgroundColorCompleted: color_const_1.default.dodgerBlue,
    bulletBorderColor: color_const_1.default.cloudyBlue300,
    bulletBorderSize: size_const_1.default.smallest,
    bulletColor: color_const_1.default.white,
    bulletInnerDescriptionPaddingVertical: spacing_const_1.default.xs,
    bulletInnerDescriptionPaddingHorizontal: spacing_const_1.default.md,
    bulletBorderRadius: '100px',
    // </editor-fold>
    // <editor-fold desc="Road styling">
    roadBackgroundColorCompleted: color_const_1.default.dodgerBlue,
    roadBackgroundColorUncompleted: color_const_1.default.cloudyBlue300,
    roadWidth: size_const_1.default.smallest,
    roadMinHeight: size_const_1.default.large,
    // </editor-fold>
};
exports.default = milestoneTracker;
